import { gql } from '@apollo/client';

export const PLAN_RECOMMENDATION = gql`
  query Plans($id: ID!) {
    recommendation(id: $id) {
      id
      title
      image
    }
  }
`;

export const PLANS = gql`
  query Plans(
    $contractorId: String! = ""
    $isHidden: Boolean! = false
    $preApproved: Boolean
    $meta: JSON
    $lastViewed: String
    $state: String
    $county: String
    $city: String
    $page: Int
    $pageSize: Int
  ) {
    plans(
      contractorId: $contractorId
      isHidden: $isHidden
      preApproved: $preApproved
      meta: $meta
      lastViewed: $lastViewed
      state: $state
      county: $county
      city: $city
      page: $page
      pageSize: $pageSize
    ) {
      items {
        id
        title
        contractorId
        url
        decorId
        image
        isHidden
        preApproved
        meta
        planSVG
        planId
        available
        photos
      }
      totalCount
    }
  }
`;

export const GUEST_PLANS = gql`
  query Plans($meta: JSON) {
    guestPlans(meta: $meta) {
      id
      title
      contractorId
      url
      decorId
      image
      specifications
      isHidden
      meta
      planSVG
      planId
      available
    }
  }
`;

// TODO: add contractorId, description when it's ready
export const PLAN = gql`
  query Plans($id: ID!) {
    plan(id: $id) {
      id
      title
      url
      contractorId
      image
      specifications
      photos
      isHidden
      meta
      decorId
      planSVG
      planId
      hasARModel
      planCost
      isModular
      isManufactured
      preApproved
      fixPrice
      sourcePlan
      available
      preApprovedArea
    }
  }
`;

export const PLAN_VIEW = gql`
  query Plans($id: ID!) {
    planView(id: $id) {
      id
      contractorId
      url
      image
      photos
      meta
      specifications
      planSVG
      planId
      hasARModel
      planCost
      isModular
      isManufactured
      preApproved
      fixPrice
      available
      preApprovedArea
    }
  }
`;

export const GET_SUMMARY = gql`
  query Summary($id: ID!) {
    getSummary(id: $id) {
      data
    }
  }
`;

export const GET_PLANS_COUNT = gql`
  query Plans {
    plansCount {
      total
    }
  }
`;
